import {
  getDeviceVoiceData,
  getSelectedDeviceData,
  selectDevice,
} from "../../redux/voiceControl-slice";
import { useDispatch, useSelector } from "react-redux";
import { ReactComponent as DropDownIcon } from "../../assets/icons/select-arrow.svg";
import { Link } from "../../components";
import cn from "classnames";
import { deviceImages } from "../../constants/images";
import { deviceStatus } from "../../constants/voice";
import { getModelName } from "../../utils";
import styles from "./VoiceDeviceCard.module.scss";

export function VoiceDeviceCard({ device }) {
  const deviceSelected = useSelector(getSelectedDeviceData);
  const deviceData = useSelector(getDeviceVoiceData(device.cloudId));
  const dispatch = useDispatch();
  const isSelected = device.cloudId === deviceSelected.cloudId;

  function onSelectDevice(device) {
    dispatch(selectDevice(device));
  }

  return (
    <div
      className={cn(styles.voiceDeviceCard, isSelected && styles.selected)}
      onClick={() => {
        onSelectDevice(device);
      }}
    >
      <div className={styles.deviceImage}>
        <img src={deviceImages[device.model]} alt={device.model} />
      </div>
      <div className={styles.deviceInfo}>
        <div className={styles.deviceModel}>{getModelName(device.model)}</div>
        <div className={styles.deviceFriendlyName}>
          {getModelName(device.model, device.friendly_name)}
        </div>
      </div>
      <div className={styles.deviceStatus}>
        {deviceStatus[deviceData.status]}
      </div>
      <Link
        to={`/voice/${device.cloudId}/controls`}
        className={styles.arrow}
        onClick={() => {
          onSelectDevice(device);
        }}
      >
        <DropDownIcon />
      </Link>
    </div>
  );
}
